/* global axios */

import ApiClient from './ApiClient';

class AiSuggestionsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  generate(conversationId) {
    return axios.post(`${this.url}/${conversationId}/ai_reply_suggestions`);
  }
}

export default new AiSuggestionsAPI();
